import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
import qs from 'qs';

export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_OVERVIEWS',
    url: ``,
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = '/api/machines_produce_board';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qs.stringify(param)]);

  return [data || {}, isRequestSuccessed];
});
